import script from "./OfSmsWinners.vue?vue&type=script&setup=true&lang=js"
export * from "./OfSmsWinners.vue?vue&type=script&setup=true&lang=js"

import "./OfSmsWinners.vue?vue&type=style&index=0&id=29bd132d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bd132d"]])

export default __exports__